import { defineStore } from "pinia"
import HomeServices from "@/services/home/HomeServices"
import { computed, ref } from "vue"

export const useGeneralStore = defineStore('general', () => {
    const categorys = ref([])
    const products = ref([])
    const productsShop = ref({})
    const bannerPromoHome = ref([])

    const getCategorys = async () => {
        try {
            const response = await HomeServices.getCategorys()
            console.log('RESPONSE CATEGORYS', response)
        } catch (error) {
            console.log('error', error)
        }
    }

    const getDataEcommerce = async () => {
        try {
            const response = await HomeServices.getProducts()
            const { first_products, banners } = response

            products.value = first_products?. data || []
            bannerPromoHome.value = banners || []
            productsShop.value = first_products || {}
            console.log('RESPONSE getProducts', response)
        } catch (error) {
            console.log('error', error)
        }
    }

    const productsTending = computed(() => {
        return products.value.slice(0, 7) || []
    })

    const bannerPromo = computed(() => {
        return bannerPromoHome.value[0] || {}
    })

    const shopProducts = computed(() => {
        return productsShop.value || {}
    })

    return {
        categorys,
        productsTending,
        shopProducts,
        bannerPromo,
        getCategorys,
        getDataEcommerce
    }
  })